import MainPageSalaDeSituacao from '@/screens/sala_situacao/MainPage.vue'
import { items } from '@/screens/sala_situacao/config.js'
import * as inteligencia from '@/screens/sala_situacao/config-inteligencia.js'

const produtividade = [
  {
    path: 'sala-de-situacao',
    name: 'sala-de-situacao',
    component: MainPageSalaDeSituacao,
    redirect: { name: 'sala-de-situacao/home' },
    children: [...items]
  },
  {
    path: 'inteligencia-territorial',
    name: 'inteligencia-territorial',
    component: MainPageSalaDeSituacao,
    redirect: { name: 'inteligencia-territorial/home' },
    children: [...inteligencia.items]
  }
]

export default produtividade



// WEBPACK FOOTER //
// ./src/router/salaSituacao.js